export const BASE_URL: string = 'https://api.onlinedokument.ch';
export const WEBSITE_BASE_URL: string = 'https://www.onlinedokument.ch';
// export const BASE_URL: string = 'http://localhost:8000';
// export const WEBSITE_BASE_URL: string = 'http://localhost:9000';

export const API_LOGIN: string = '/login';
export const TOKEN_NAME: string = 'user';
export const TINYMCE_EDITOR_API_KEY: string =
    '2jzlctjdwhwr5k92jjnw6t71w1qghc7xbk6diuglo76553ml';

export const USER_ROLE_ADMIN = 1;
export const USER_ROLE_CUSTOMER = 2;

export const URL_TYPE_ID_ARTICLE: number = 1;

export const LANGUAGE_ENGLISH: number = 1;
export const LANGUAGE_GERMAN: number = 2;

export const URL_TYPE_ARTICLE: number = 1;

export const API_EDITOR_FILE_UPLOAD: string = BASE_URL + '/editorFileUpload';

export const APP_LANGAUGE: any = {
    en: 1,
    de: 2,
    fr: 3,
};

export const LANGAUGE_NAME: any = {
    en: 'English',
    de: 'German',
    fr: 'French',
};

export const PAGINATION_DEFAULT_PAGE: number = 1;
export const PAGINATION_DEFAULT_LIMIT: number = 9;

export const ROUT_PAGE_NAME_UPDATE_DOCUMENT_EN: string = 'update-document';
export const ROUT_PAGE_NAME_UPDATE_DOCUMENT_DE: string = 'update-dokument';
export const ROUT_PAGE_NAME_UPDATE_DOCUMENT_FR: string = 'document-reviser';

export const LANGUAGE_ID_ENGLISH = 1;
export const LANGUAGE_ID_GERMAN = 2;
export const LANGUAGE_ID_FRENCH = 3;

export const DOCUMENT_TEMPLATE_TRANSLATION_SUBFOLDER_TYPE_FAQ = 1;
export const DOCUMENT_TEMPLATE_TRANSLATION_SUBFOLDER_TYPE_PREVIEW_IMAGES = 2;
export const DOCUMENT_TEMPLATE_TRANSLATION_SUBFOLDER_TYPE_DOCUMENT_TEMPLATE_ONLY_PREVIEW_IMAGES = 3;

export const UPLOAD_IMAGE_ALLOWED_FILE_EXTENSIONS = [
    'png',
    'jpg',
    'jpeg',
    'webp',
];

export const DOCUMENT_DETAIL_PAGE_INFO = 'documentDetailPageInfo';
export const CREATE_DOCUMENT_PAGE_INFO = 'createDocumentPageInfo';
export const DOCUMENT_TEMPLATE_ONLY_INFO = 'documentTemplateOnlyPageInfo';
export const DOCUMENT_TEMPLATE_PREVIEW_IMAGES = 'documentTemplatePreviewImages';

export const DOCUMENT_CATEGORY_NAME_MAX_LENGTH = 100;
export const USER_CREATED_DOCUMENT_TYPE_FILLED_DOCUMENT = 'filledDocument';
export const USER_CREATED_DOCUMENT_TYPE_DOCUMENT_TEMPLATE_ONLY = 'documentTemplate';

export const PREVIEW_END = "[[PREVIEW_END]]";
